import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClientModule } from '@app/client/client.module';
import { CompleteDataBoilerMaintenanceComponent } from '@app/dashboard/components/complete-data-boiler-maintenance/complete-data-boiler-maintenance.component';
import { ContactUsWrapperComponent } from '@app/dashboard/components/contact-us-wrapper/contact-us-wrapper.component';
import { ContactUsComponent } from '@app/dashboard/components/contact-us/contact-us.component';
import { GeneralInfoFooterComponent } from '@app/dashboard/components/general-info-footer/general-info-footer.component';
import { MoveWizardModule } from '@app/move-wizard/move-wizard.module';
import { MoveModalModule } from '@app/move/move-modal.module';
import { MoveModule } from '@app/move/move.module';
import { RealEstateAgentModule } from '@app/real-estate-agent/real-estate-agent.module';
import { SharedModule } from '@app/shared/shared.module';
import { CheckItemModule } from '@app/ui/check-item/check-item.module';
import { SvgModule, TrackAndTraceModule } from '@smooved/ui';
import { CardModule } from '../card/card.module';
import { ContractModule } from '../contract/contract.module';
import { WaterModule } from '../water/water.module';
import { CompleteDataEnergyComponent } from './components/complete-data-energy/complete-data-energy.component';
import { CompleteDataTelecomComponent } from './components/complete-data-telecom/complete-data-telecom.component';
import { CompleteDataComponent } from './components/complete-data/complete-data.component';
import { ContractsSomethingElseComponent } from './components/contracts-something-else/contracts-something-else.component';
import { DashboardServicesAllComponent } from './components/dashboard-services-all/dashboard-services-all.component';
import { DashboardServicesComponent } from './components/dashboard-services/dashboard-services.component';
import { LogisticsComponent } from './components/logistics/logistics.component';
import { MajorServiceListComponent } from './components/major-service-list/major-service-list.component';
import { MinorServiceListComponent } from './components/minor-service-list/minor-service-list.component';
import { MinorServiceComponent } from './components/minor-service/minor-service.component';
import { PostComponent } from './components/post/post.component';
import { ReadingMetersComponent } from './components/reading-meters/reading-meters.component';
import { UtilityTransferSectionComponent } from './components/utility-transfer-section/utility-transfer-section.component';
import { WaterTransferCardComponent } from './components/water-transfer-card/water-transfer-card.component';
import { DashboardContainer } from './containers/dashboard/dashboard.container';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
    declarations: [
        DashboardContainer,
        MajorServiceListComponent,
        MinorServiceComponent,
        MinorServiceListComponent,
        LogisticsComponent,
        PostComponent,
        DashboardServicesComponent,
        DashboardServicesAllComponent,
        CompleteDataComponent,
        ContractsSomethingElseComponent,
        ReadingMetersComponent,
        CompleteDataEnergyComponent,
        CompleteDataTelecomComponent,
        ContactUsComponent,
        ContactUsWrapperComponent,
        GeneralInfoFooterComponent,
        CompleteDataBoilerMaintenanceComponent,
        WaterTransferCardComponent,
        UtilityTransferSectionComponent,
    ],
    exports: [MinorServiceListComponent],
    imports: [
        SharedModule,
        DashboardRoutingModule,
        SvgModule,
        CardModule,
        ContractModule,
        WaterModule,
        RealEstateAgentModule,
        MoveModule,
        MoveWizardModule,
        ClientModule,
        CheckItemModule,
        TrackAndTraceModule,
        MoveModalModule,
        NgOptimizedImage,
    ],
})
export class DashboardModule {}
